import IconPause from '@fortuneo/ui-icons/general/IconPause'
import IconPlay from '@fortuneo/ui-icons/general/IconPlay'
import IconReplay from '@fortuneo/ui-icons/general/IconReplay'
import React, { type FC, type SyntheticEvent } from 'react'

type Props = {
  isPlaying: boolean
  hasEnded: boolean
  onClick: (e: SyntheticEvent) => void
}

export const ControlsPlay: FC<Props> = ({ isPlaying, hasEnded, onClick }) => {
  let Icon = IconPlay

  if (hasEnded) {
    Icon = IconReplay
  } else if (isPlaying) {
    Icon = IconPause
  }

  return (
    <button
      aria-label={isPlaying ? 'pause' : 'lecture'}
      className="h-[60px] w-[60px] rounded-full bg-theme-primary-main p-0 opacity-90"
      type="button"
      onClick={onClick}
    >
      <Icon className="fill-white-50" size={35} />
    </button>
  )
}
